import Inner from './inner'

const ButtonClick = ({
  name,
  type = 'button',
  onClick,
  size = 'small',
  color = 'primary',
  className,
  ...args
}) => {
  const base = `relative w-full md:w-fit overflow-hidden border font-ttDrugsTrial uppercase group transition-all duration-500`
  const sizes = {
    small:
      'px-[16px] py-[12px] md:px-[30px] md:py-[20px] text-rectangleButtonMobile md:text-rectangleButtonDesktop',
    big: 'px-[18px] py-[15px] md:px-[35px] md:py-[25px] text-rectangleBigButtonMobile md:text-rectangleBigButtonDesktop',
  }
  const textColor = {
    primary: 'border-olive text-olive',
    secondary: 'border-dune text-dune',
  }

  return (
    <button
      type={type}
      onClick={onClick}
      {...args}
      className={`${base} ${sizes[size]} ${textColor[color]} ${className}`}
    >
      <Inner name={name} color={color} />
    </button>
  )
}

export default ButtonClick
